import { AHSeparator, AHText, Box, Card, useLayoutContext } from "arkh";
import React, { useEffect, useMemo, useRef } from "react";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { KPITeamGroup } from "../Edit/KPITeamGroup";
import { useIntlTokens } from "../../../components/mobile/useIntlTokens";
import { KPITeamGroupGoalItem } from "../components/KPITeamGroupGoalItem";
import { FlatList } from "react-native";
import {
  ListSectionHeader,
  ListSectionHeaderTitle,
} from "../../../components/atoms/ListSectionHeader";
import { GoalDirectionSegmentedControl } from "../components/GoalDirectionSegmentedControl";
import { Lottie, LottieRef } from "../../../components/Lottie";
import { KeyboardAwareScrollView } from "react-native-keyboard-controller";

export function KPICreateGoals(props: {
  onSkip(): void;
  goalsActive: boolean;
  setGoalsActive(active: boolean): void;
  goalDirection: "greater" | "less";
  setGoalDirection: (direction: "greater" | "less") => void;
  selectedTeams: KPITeamGroup[];
  setSelectedTeams(
    update: ((sections: KPITeamGroup[]) => KPITeamGroup[]) | KPITeamGroup[]
  ): void;
}) {
  const ref = useRef<FlatList<KPITeamGroup>>(null);
  const insets = useSafeAreaInsets();

  const layout = useLayoutContext();
  const space = "medium";
  const padding = layout.space[space];
  const intl_token = useIntlTokens();
  const lottieRef = useRef<LottieRef>(null);
  useEffect(() => {
    lottieRef.current?.play();
  }, []);

  const ListHeaderComponent = useMemo(() => {
    return (
      <Box spaceBottom="large">
        <ListSectionHeader>
          <ListSectionHeaderTitle>
            {intl_token.SetTargets}
          </ListSectionHeaderTitle>
        </ListSectionHeader>
        {props.goalsActive ? (
          <Card defaultBorder>
            <Box style={{ flex: 1 }}>
              <GoalDirectionSegmentedControl
                goalDirection={props.goalDirection}
                setGoalDirection={props.setGoalDirection}
              />
            </Box>
          </Card>
        ) : null}
      </Box>
    );
  }, [
    intl_token.SetTargets,
    props.goalDirection,
    props.goalsActive,
    props.setGoalDirection,
  ]);

  if (!props.goalsActive) {
    return (
      <Box
        space={space}
        style={{ flex: 1, alignItems: "center", justifyContent: "center" }}
      >
        <AHText type="title">{intl_token.SetTargets}</AHText>
        <Box spaceVertical="xlarge">
          <Lottie
            hardwareAccelerationAndroid
            speed={1}
            autoPlay
            ref={lottieRef}
            key="lottie"
            style={{ height: 200 }}
            resizeMode="cover"
            loop
            source={require("./goal-arrow.json")}
          />
        </Box>
      </Box>
    );
  }

  return (
    <FlatList<KPITeamGroup>
      ref={ref}
      contentInsetAdjustmentBehavior="always"
      keyboardShouldPersistTaps="handled"
      contentContainerStyle={{
        padding,
        paddingBottom: insets.bottom,
      }}
      data={props.selectedTeams}
      ItemSeparatorComponent={AHSeparator}
      renderScrollComponent={(props) => <KeyboardAwareScrollView {...props} />}
      ListHeaderComponent={ListHeaderComponent}
      renderItem={({ item, index }) => (
        <KPITeamGroupGoalItem
          key={item.teamId + (item.sectionId ?? "")}
          item={item}
          isFirst={index === 0}
          isLast={index === props.selectedTeams.length - 1}
          goalDirection={props.goalDirection}
          setSelectedTeams={props.setSelectedTeams}
        />
      )}
    />
  );
}
